import {
  ADD_SKILLS_REQUEST,
  ADD_SKILLS_SUCCESS,
  ADD_SKILLS_FAIL
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const AddSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SKILLS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ADD_SKILLS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ADD_SKILLS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default AddSkillsReducer;
